import React from "react";
import ProgramacionItem from "./ProgramacionItem";

/**
 * Lista de programaciones en grid
 * @param {Array} items - Array de objetos de programación
 * @param {Function} getSectorName - Función para obtener nombre de sector por válvulaId
 * @param {Function} onEdit - Callback al editar una programación
 * @param {Function} onDelete - Callback al eliminar una programación
 */
export default function ProgramacionList({ items, getSectorName, onEdit, onDelete }) {
  return (
    <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-6">
      {items
        .filter((prog) => prog != null)
        .map((prog) => (
          <ProgramacionItem
            key={prog.programacionId}
            prog={prog}
            getSectorName={getSectorName}
            onEdit={() => onEdit(prog)}
            onDelete={() => onDelete(prog)}
          />
        ))}
    </div>
  );
}
